export default "__VITE_ASSET__be9f7230__"